import React from 'react'
import {AccordionBase} from './accordion-base'
import {AccordionHeaderStyle} from './accordion-item'
import {AccordionItemData} from './types'
import {useAccordion} from './use-accordion'

export interface AccordionProps {
  items: AccordionItemData[]
  headerStyle?: AccordionHeaderStyle
  multi?: boolean
  disabled?: boolean
  className?: string
  defaultOpenedIds?: string[]
}

/**
 * Uncontrolled accordion component
 */
export const Accordion = React.memo(
  ({
    items,
    multi,
    disabled,
    defaultOpenedIds,
    headerStyle,
    className
  }: AccordionProps) => {
    const {openedIds, onItemClick} = useAccordion({
      items,
      multi,
      disabled,
      defaultOpenedIds
    })

    return (
      <AccordionBase
        items={items}
        headerStyle={headerStyle}
        openedIds={openedIds}
        onItemClick={onItemClick}
        disabled={disabled}
        className={className}
      />
    )
  }
)
